import React, { Component } from 'react';
import { isEmpty } from "lodash";
import { TableRow, TableCell, Button, TableHead, TableBody, Card, Grid, Box, IconButton, Typography } from '@material-ui/core';
import { TableLayout } from '../../containers/Layout';
import { SendRounded } from '@material-ui/icons';
import PopUp from '../../../../../commonModules/interface/PopUp';
import { blue, grey, teal, amber } from '@material-ui/core/colors';

class DemandTransferReaFrom extends Component {
    state = { }

    formatRea = (shopID, newQty) => {
        const { resa } = this.props;

        console.log('====================================');
        console.log({resa});
        console.log('====================================');
        let rea = Object.assign({}, resa)
        let newProdList = []
        resa.products.forEach(prod => {
            if (newQty[prod.product_id] > 0 ) {
                prod.quantity = newQty[prod.product_id] 
                newProdList.push(prod)
            }
        })
        rea.products = newProdList
        this.props.handleOpenRea(shopID, rea)
    }
    
    findStocks = () => {// find shops with stocks of this product
        const { AVAILABLE, SHOPS, PRODUCTS, product, resa, resaProds } = this.props
        console.log('====================================');
        console.log({AVAILABLE});
        console.log('====================================');

        if(AVAILABLE){
            let prodQty = {}
            let qtyToRea = {}
            let shopList = Object.values(SHOPS).filter(shop => !shop.shop_disabled)
            // let shopList = Object.values(SHOPS).filter(shop => !shop.shop_disabled && shop.id !== resa.shop_id)
            let newShopList = []
            let currentShop = {}
            let shopListSorted = []
            let prodList = resa.products.filter( prod => resaProds[prod.product_id].qtyMissing > 0 )

            shopList.map( shop => {
                // let sumShopLine = 0
                let countProdinLine = 0
                prodList.map( prod => {
                    // sumShopLine += AVAILABLE[`${shop.id}|${prod.product_id}|AVAILABLE`] ? AVAILABLE[`${shop.id}|${prod.product_id}|AVAILABLE`].quantity : 0  
                    prodQty[`${shop.id}|${prod.product_id}`] = AVAILABLE[`${shop.id}|${prod.product_id}|AVAILABLE`] ? AVAILABLE[`${shop.id}|${prod.product_id}|AVAILABLE`].quantity : 0  
                    
                    let missing = resaProds[prod.product_id].qtyMissing 

                    if (AVAILABLE[`${shop.id}|${prod.product_id}|AVAILABLE`] && AVAILABLE[`${shop.id}|${prod.product_id}|AVAILABLE`].quantity > 0) {
                        if(!qtyToRea[shop.id]) {
                            qtyToRea[shop.id] = {}
                        }
                        if (AVAILABLE[`${shop.id}|${prod.product_id}|AVAILABLE`].quantity < missing) {
                            qtyToRea[shop.id][prod.product_id] = AVAILABLE[`${shop.id}|${prod.product_id}|AVAILABLE`].quantity
                            countProdinLine ++

                        } else {
                            qtyToRea[shop.id][prod.product_id] = missing
                            countProdinLine += 2
                        }
                    } 
                })

                shop.countProdinLine = countProdinLine
                
                if (shop.id == resa.shop_id){
                    currentShop = shop
                } else {
                    newShopList.push(shop)
                }
            })

            shopListSorted = newShopList.sort((shopA, shopB) => shopB.countProdinLine - shopA.countProdinLine);
            shopListSorted.unshift(currentShop)
            return[
                shopListSorted.map( shop => (
                    shop.countProdinLine > 0 &&
                    <TableRow key={shop.id} 
                        style={{ backgroundColor: (shop.id === resa.shop_id && "lavender") }}
                    >
                        <TableCell
                            style={{
                                position: 'sticky',
                                left: 0,
                                background: (shop.id === resa.shop_id ? "lavender" :'white'),
                                zIndex: 800,
                            }} 
                        >
                            <Box
                                style={{
                                    width: "200px"
                                }}
                            >
                                {SHOPS[shop.id].name }
                                {/* {shop.countProdinLine == prodList.length * 2 &&
                                    <IconButton color="success">
                                        <CheckCircleOutlineRounded color="success"/>
                                    </IconButton>
                                } */}
                            </Box>
                        </TableCell>
                        {prodList.map( prod => (
                            <TableCell>
                                <Box p={1} 
                                    style={{
                                        backgroundColor: ( 
                                        (prodQty[`${shop.id}|${prod.product_id}`] >= resaProds[prod.product_id].qtyMissing)  ? teal[100] : 
                                        prodQty[`${shop.id}|${prod.product_id}`] > 0 ? amber[100] : grey[300]) ,
                                        borderRadius: "5px",
                                        width: "100px",
                                        textAlign: "center"
                                    }}
                                >
                                    {prodQty[`${shop.id}|${prod.product_id}`]}

                                </Box>
                            </TableCell>
                            ))
                        }
                        {this.props.handleOpenRea &&
                            <TableCell>
                                {shop.id === resa.shop_id ?
                                <Button 
                                    variant="contained"
                                    color="primary"
                                    onClick={
                                        () => this.formatRea(shop.id, qtyToRea[shop.id])
                                    }
                                >
                                   Réserver
                                </Button>
                                :
                                <IconButton 
                                    variant="contained"
                                    color="primary"
                                    onClick={
                                        () => this.formatRea(shop.id, qtyToRea[shop.id])
                                    }
                                >
                                    <SendRounded />
                                </IconButton>
                                }
                            </TableCell>

                        }
                    </TableRow>
                ))
            ]
        } else {
            return ["",false]
        }
    }

    
    render() {
        const { resaProds, resa, PRODUCTS } = this.props;
        const prodList = resa.products.filter( prod => resaProds[prod.product_id].qtyMissing > 0 )
        return (
            
                <Box p={1}>
                    <TableLayout  style={{ maxHeight: "600px"}}>
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    style={{
                                        background: 'white',
                                        zIndex: 900,
                                    }} 
                                    rowSpan={2}
                                >
                                    Magasins
                                </TableCell>
                                    { prodList.map( prod => (
                                        <TableCell 
                                            key={prod.id}
                                            style={{
                                                background: 'white',
                                            }}
                                        >
                                            {PRODUCTS[prod.product_id].name}
                                            <Typography color="secondary" variant="h6"><b>x {resaProds[prod.product_id].qtyMissing}</b></Typography>
                                        </TableCell>
                                    ))
                                    }
                                <TableCell style={{background: 'white'}} />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.findStocks()[0]}
                        </TableBody>
                    </TableLayout>
                </Box>
        );
    }
}

export default DemandTransferReaFrom;